import { getThirdPartyAuthorisationURLWithQueryParamsAndSetState } from 'supertokens-web-js/recipe/thirdpartypasswordless';
import config from './localconfig';
import { getLocaleFromPath } from '@/utils/getLocaleFromPath';
import { getServerTranslator } from '@/utils/serverI18n';
const urlBase = config.BASE_URL;

export async function signInClicked(id) {
    try {
        const authUrl = await getThirdPartyAuthorisationURLWithQueryParamsAndSetState({
            providerId: id,
            authorisationURL: `${urlBase}/auth/callback/${id}`,
        });

        // Redirect the user to the third-party provider for authentication
        window.location.assign(authUrl);
    } catch (err) {
        const { t } = getServerTranslator(getLocaleFromPath(window.location.pathname));
        if (err.isSuperTokensGeneralError === true) {
            // Custom error message from the API
            window.alert(err.message);
            console.log(err, 'error');
        } else {
            console.log('Error occurred in social SSO:', err);
            window.alert(t('auth.genericError'));
        }
    }
}
